<template lang="pug">
tbody.tableTop10-tbody2
  tr.tableTop10-bodyTr(v-for='info in infos' @click="goTo(info)")
    td.tableTop10-main2
      .tableTop10-contentRight2
        .tableTop10-tbody2Tags
          span.tableTop10-tag2.tableTop10-tag2--orange 澄清
          span.tableTop10-tag2.tableTop10-tag2--grey(v-if="info.isRss") RSS
        v-clamp.tableTop10-text2(autoresize :max-lines="2") {{ info.title }}
      .tableTop10-authorithy--mobile.show--smallScreens(v-if="type=='government'")
        .icon-more(@click="clickMore(info)")
    td.tableTop10-subcontent.order-smallScreens--3 {{ info.govOption.name }}
    td.tableTop10-subcontent.order-smallScreens--2 {{ info.updatedAtStr }}
    td.tableTop10-authorithy.show--bigScreens(v-if="type=='government'")
      .tableTop10-buttonAuthority(@click="togglePopupAddEditCommentGov(info)")
        .tableTop10-editAuthority 編輯
      .tableTop10-buttonAuthority(@click="deleteArticle(info)")
        .tableTop10-deleteAuthority 刪除
  PopupAddEditCommentGov(v-if="popupAddEditCommentGov" type='edit' :govAnnounceInfo="selectedInfo" @closePopup="popupAddEditCommentGov = false" @isSuccess="isSuccess" @isError="isError" sectionText="編輯澄清")
  PopupContentIconText(v-if="popupContentIconText" @closePopup="popupContentIconText = false" :popupSimpleText="popupSimpleText" :iconType="iconType")
  PopupOptionGov(v-if="popupOptionGov" @closePopup="popupOptionGov = false" @clickOption="clickOption")
</template>
<script>
import PopupAddEditCommentGov from '@/components/popup/popup_add_edit_comment_gov.vue';
import PopupContentIconText from '@/components/popup/popup_content_icon_text.vue';
import PopupOptionGov from '@/components/modules/mobile/popup_option_gov.vue';
import VClamp from 'vue-clamp';
export default {
  components: {
    VClamp,
    PopupAddEditCommentGov,
    PopupContentIconText,
    PopupOptionGov
  },
  props: {
    infos: Array,
    type: String
  },
  data() {
    return {
      popupAddEditCommentGov: false,
      popupContentIconText: false,
      popupOptionGov: false,
      selectedInfo: {},
      comment: {}
    };
  },
  methods: {
    goTo(info) {
      const identity = localStorage.getItem(
        this.$store.state.storageKeys.identity
      );
      if (identity !== 'government') {
        // setGtag(info.content, '公共事務', info.content, info.id)
        this.$router.push({
          path: '/gov-announce',
          query: {
            govAnnounceId: info.id,
            govOptionName: info.govOption.name,
            govOptionId: info.govOption.id
          }
        });
      }
    },
    isSuccess() {
      this.popupContentIconText = true;
      this.iconType = 'complete';
      this.popupSimpleText = '編輯完成';
    },
    isError() {
      this.popupContentIconText = true;
      this.iconType = 'error';
      this.popupSimpleText = '發生錯誤';
    },
    deleteArticle(info) {
      let route =
        this.$store.state.URLs.apiPartner + '/govAnnounces/' + info.id;
      this.$axios
        .delete(route, {
          headers: {
            'X-Line-Biz-Session': localStorage.getItem(
              this.$store.state.storageKeys.token
            )
          }
        })
        .then(() => {
          this.popupContentIconText = true;
          this.iconType = 'delete';
          this.popupSimpleText = '澄清文已刪除';
          window.location.reload();
        })
        .catch(() => {
          this.popupContentIconText = true;
          this.iconType = 'error';
          this.popupSimpleText = '發生錯誤';
        });
    },
    clickMore(info) {
      this.selectedInfo = info;
      this.popupOptionGov = true;
    },
    clickOption(type) {
      if (type == 'edit') this.popupAddEditCommentGov = true;
      else if (type == 'delete') this.deleteArticle(this.selectedInfo);
    },
    togglePopupAddEditCommentGov(info) {
      this.popupAddEditCommentGov = !this.popupAddEditCommentGov;
      this.selectedInfo = info;
    }
  }
};
</script>

<style scoped src="./table_gov_body.vue.css"></style>
